var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_c('message-header', {
    attrs: {
      "message-header": _vm.messageHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_c('save-button', {
    staticClass: "right-15 top-15",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "save": _vm.saveBeneficiary
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', [_vm._v("\n      Modifier le compte bénéficiaire de "), _c('br'), _vm._v("\n      " + _vm._s(_vm.beneficiaryToEdit.firstname) + "\n      "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.beneficiaryToEdit.lastname))])]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center my-10"
  }, [_c('ProfilePicture', {
    attrs: {
      "show-edit-link": true,
      "other-object": _vm.beneficiaryToEdit,
      "size": "max-w-36 w-36 h-36"
    },
    on: {
      "changeProfileImageToAnotherUser": function (urlPicture) {
        _vm.changeProfileImageToAnotherUser(urlPicture);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mb-10"
  }, [_c('div', {
    staticClass: "border-dashed border-gray-300 border-2 rounded-lg"
  }, [_c('div', {
    staticClass: "my-4 mx-8"
  }, [_c('p', {
    staticClass: "text-sm italic font-medium text-gray-600"
  }, [_vm._v("\n            Nom d'utilisateur\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n            " + _vm._s(_vm.beneficiaryToEdit.username) + "\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/10"
  }, [_c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "firstname",
      "libelle": "Prénom",
      "value": _vm.beneficiaryToEdit.firstname,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.firstname'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.beneficiaryToEdit.firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "lastname",
      "libelle": "Nom",
      "value": _vm.beneficiaryToEdit.lastname,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.lastname'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.beneficiaryToEdit.lastname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "company",
      "libelle": "Entreprise",
      "value": _vm.beneficiaryToEdit.company,
      "disabled": true
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "fonction",
      "libelle": "Fonction",
      "value": ((_vm.structure || {}).pivot || {}).function
    },
    on: {
      "input": function (newValue) {
        ((_vm.structure || {}).pivot || {}).function = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "email",
      "type": "email",
      "libelle": "Email",
      "value": _vm.beneficiaryToEdit.email,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.email'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.beneficiaryToEdit.email = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "phone_number",
      "libelle": "Téléphone",
      "value": _vm.beneficiaryToEdit.phone_number,
      "error": true,
      "type": "tel"
    },
    on: {
      "input": function (newValue) {
        _vm.beneficiaryToEdit.phone_number = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-full",
    attrs: {
      "name": "address",
      "libelle": "Adresse postale",
      "value": _vm.beneficiaryToEdit.address
    },
    on: {
      "input": function (newValue) {
        _vm.beneficiaryToEdit.address = newValue;
      }
    }
  }), _vm._v(" "), _c('password-modifier', {
    attrs: {
      "grid": "grid grid-cols-12 gap-x-4 gap-y-5",
      "password-input-size": "col-span-full lg:col-span-6",
      "confirm-password-input-size": "lg:col-span-6",
      "auth-password-input-size": "lg:col-span-6",
      "confirm-button-size": "lg:col-span-6",
      "password": _vm.beneficiaryToEdit.password,
      "confirm-password": _vm.beneficiaryToEdit.password_confirmation,
      "auth-password": _vm.authPassword,
      "errors": _vm.errors
    },
    on: {
      "fillPassword": function (newValue) {
        _vm.beneficiaryToEdit.password = newValue;
      },
      "fillConfirmPassword": function (newValue) {
        _vm.beneficiaryToEdit.password_confirmation = newValue;
      },
      "fillAuthPassword": function (newValue) {
        _vm.authPassword = newValue;
      },
      "confirmNewPassword": _vm.confirmNewPassword
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center mt-15 space-y-6"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-indigo-300",
      "bg-color-square": "bg-indigo-200",
      "icon-color": "text-indigo-600",
      "libelle": "Détacher le carnet de parcours de la structure",
      "responsive": true,
      "icon": "log-out"
    },
    on: {
      "clickAction": _vm.changeDisplayDetachBeneficiaryPopup
    }
  }), _vm._v(" "), _vm.isDetachBeneficiaryDisplayed ? _c('p', {
    staticClass: "text-indigo-600 italic text-sm"
  }, [_vm._v("\n        Êtes vous sûr de vouloir détacher le Neopass de\n        " + _vm._s(_vm.beneficiaryToEdit.firstname) + "\n        " + _vm._s(_vm.beneficiaryToEdit.lastname) + " de votre structure ?\n      ")]) : _vm._e(), _vm._v(" "), _vm.isDetachBeneficiaryDisplayed ? _c('div', {
    staticClass: "flex space-x-5",
    attrs: {
      "id": "detachButtons"
    }
  }, [_c('action-button', {
    staticClass: "relative flex flex-row",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": _vm.changeDisplayDetachBeneficiaryPopup
    }
  }), _vm._v(" "), _c('action-button', {
    staticClass: "relative flex flex-row",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "CONFIRMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirmDetachBeneficiary();
      }
    }
  })], 1) : _vm._e()], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }